import apiClient from '@/shared/services/apiClient'
import type { SubmitFeedbackRequest, ApiResponseFeedbackResponse } from '../types'

const SUPPORT_BASE_URL = '/api/v1/support'

class SupportService {
  async submitFeedback(request: SubmitFeedbackRequest): Promise<ApiResponseFeedbackResponse> {
    const response = await apiClient.post<ApiResponseFeedbackResponse>(
      `${SUPPORT_BASE_URL}/feedback`,
      request
    )
    return response.data
  }
}

export default new SupportService()
